import { FastAverageColor } from 'fast-average-color';

export const rgbToHsl = (rgb: number[]): number[] => {
  // Make r, g, and b fractions of 1
  const red = rgb[0] / 255;
  const green = rgb[1] / 255;
  const blue = rgb[2] / 255;

  // Find greatest and smallest channel values
  const cmin = Math.min(red, green, blue);
  const cmax = Math.max(red, green, blue);
  const delta = cmax - cmin;
  let hue = 0;
  let saturation = 0;
  let lightness = 0;

  // Calculate hue
  // No difference
  if (delta === 0) {
    hue = 0;
    // Red is max
  } else if (cmax === red) {
    hue = ((green - blue) / delta) % 6;
    // Green is max
  } else if (cmax === green) {
    hue = (blue - red) / delta + 2;
    // Blue is max
  } else {
    hue = (red - green) / delta + 4;
  }

  hue = Math.round(hue * 60);

  // Make negative hues positive behind 360°
  if (hue < 0) {
    hue += 360;
  }

  // Calculate lightness
  lightness = (cmax + cmin) / 2;

  // Calculate saturation
  saturation = delta === 0 ? 0 : delta / (1 - Math.abs(2 * lightness - 1));

  // Multiply l and s by 100
  saturation = +(saturation * 100).toFixed(1);
  lightness = +(lightness * 100).toFixed(1);

  return [hue, saturation, lightness];
};

export const rgbToHex = (rgb: number[]): string => {
  let r = rgb[0].toString(16);
  let g = rgb[1].toString(16);
  let b = rgb[2].toString(16);

  if (r.length === 1) {
    r = `0${r}`;
  }
  if (g.length === 1) {
    g = `0${g}`;
  }
  if (b.length === 1) {
    b = `0${b}`;
  }

  return `#${r}${g}${b}`;
};

const fac = new FastAverageColor();

export const getColor = async (image: HTMLImageElement) => {
  const color = await fac.getColorAsync(image);
  return color;
};
